import { useState } from 'react';
import { supabase } from '../utils/supabaseClient';

function Login() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const [linkGesendet, setLinkGesendet] = useState(false);

    const passwortVergessen = async () => {
        setError('');
        if (!email.includes('@')) {
            setError('Bitte zuerst die E-Mail-Adresse eingeben.');
            return;
        }
        const { error } = await supabase.auth.resetPasswordForEmail(email, { redirectTo: window.location.origin });
        if (error) setError(error.message);
        else setLinkGesendet(true);
    };

    const handleLogin = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);
        const { error } = await supabase.auth.signInWithPassword({ email, password });
        if (error) {
            setError(error.message === 'Invalid login credentials'
                ? 'Ungültige Anmeldedaten. Bitte versuche es erneut.'
                : error.message
            );
        }
        setLoading(false);
    };

    return (
        <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#f1f5f9' }}>
            <div style={{ width: '100%', maxWidth: '400px', backgroundColor: 'white', borderRadius: '16px', padding: '40px', boxShadow: '0 4px 24px rgba(0,0,0,0.08)' }}>
                <div style={{ textAlign: 'center', marginBottom: '32px' }}>
                    <div style={{ fontSize: '36px', fontWeight: 700, color: '#7B5EA7', letterSpacing: '-0.5px', lineHeight: 1 }}>
                        Optero
                    </div>
                    <div style={{ fontSize: '11px', fontWeight: 600, letterSpacing: '3px', textTransform: 'uppercase', color: '#5E8FAE', marginTop: '6px' }}>
                        Handwerkersoftware
                    </div>
                </div>

                <form onSubmit={handleLogin} style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                    <div>
                        <label style={{ display: 'block', fontSize: '13px', fontWeight: 500, color: '#374151', marginBottom: '6px' }}>
                            E-Mail
                        </label>
                        <input
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                            autoFocus
                            placeholder="name@firma.de"
                            style={{ width: '100%', border: '1px solid #d1d5db', borderRadius: '8px', padding: '9px 12px', fontSize: '14px', outline: 'none', boxSizing: 'border-box' }}
                            onFocus={e => e.target.style.borderColor = '#7B5EA7'}
                            onBlur={e => e.target.style.borderColor = '#d1d5db'}
                        />
                    </div>
                    <div>
                        <label style={{ display: 'block', fontSize: '13px', fontWeight: 500, color: '#374151', marginBottom: '6px' }}>
                            Passwort
                        </label>
                        <input
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                            style={{ width: '100%', border: '1px solid #d1d5db', borderRadius: '8px', padding: '9px 12px', fontSize: '14px', outline: 'none', boxSizing: 'border-box' }}
                            onFocus={e => e.target.style.borderColor = '#7B5EA7'}
                            onBlur={e => e.target.style.borderColor = '#d1d5db'}
                        />
                    </div>

                    {error && (
                        <p style={{ fontSize: '13px', color: '#dc2626', margin: 0 }}>{error}</p>
                    )}
                    {linkGesendet && (
                        <p style={{ fontSize: '13px', color: '#059669', margin: 0 }}>Link zum Zurücksetzen ist unterwegs.</p>
                    )}

                    <button
                        type="submit"
                        disabled={loading}
                        style={{ width: '100%', backgroundColor: '#1C3557', color: 'white', border: 'none', borderRadius: '8px', padding: '11px', fontSize: '14px', fontWeight: 600, cursor: loading ? 'not-allowed' : 'pointer', opacity: loading ? 0.6 : 1, marginTop: '4px' }}
                    >
                        {loading ? 'Wird angemeldet…' : 'Anmelden'}
                    </button>
                    <button
                        type="button"
                        onClick={passwortVergessen}
                        style={{ background: 'none', border: 'none', color: '#6b7280', fontSize: '13px', cursor: 'pointer', textDecoration: 'underline' }}
                    >
                        Passwort vergessen?
                    </button>
                </form>
            </div>
        </div>
    );
}

export default Login;
